// extracted by mini-css-extract-plugin
module.exports = {"DisplayBox":"DisplayBox_DisplayBox_1GhBl","DisplayBoxTopBorder":"DisplayBox_DisplayBoxTopBorder_33vWp","DisplayBoxContent":"DisplayBox_DisplayBoxContent_1QzrK"};